import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/industries/martech/original-page.tsx");
